/**
 * ChampionModelRegistry — Single Responsibility: mapeo champId → ChampionPainter.
 * Implementa el patrón Strategy + Open/Closed: nuevos campeones se registran aquí,
 * nunca se agregan if/else en canvasRenderer.js.
 *
 * Contrato público:
 *   ChampionModelRegistry.register(champId: string, painter: ChampionPainter): void
 *   ChampionModelRegistry.get(champId: string): ChampionPainter
 *
 * ChampionPainter interface: { paint(ctx, pos, radius, entity): void }
 */

import { GarenPainter } from './painters/garenPainter.js';
import { AshePainter  } from './painters/ashePainter.js';
import { RyzePainter  } from './painters/ryzePainter.js';

/** Painter por defecto: círculo sólido con color del equipo */
const DefaultPainter = {
  paint(_ctx, _pos, _radius, _entity) {
    // no-op: el renderEntity ya dibuja el círculo base antes de llamar al painter
  }
};

const registry = new Map([
  ['garen', GarenPainter],
  ['ashe',  AshePainter],
  ['ryze',  RyzePainter]
]);

export const ChampionModelRegistry = {
  /**
   * Registra un nuevo painter para un campeón.
   * @param {string} champId  e.g. 'zed', 'jinx'
   * @param {{ paint: Function }} painter
   */
  register(champId, painter) {
    registry.set(champId.toLowerCase(), painter);
  },

  /**
   * Retorna el painter para el champId dado, o DefaultPainter si no está registrado.
   * @param {string} champId
   * @returns {{ paint: Function }}
   */
  get(champId) {
    return registry.get((champId || '').toLowerCase()) ?? DefaultPainter;
  }
};
